import { render } from "./HomeAluno.vue?vue&type=template&id=827849f8"
import script from "./HomeAluno.vue?vue&type=script&lang=js"
export * from "./HomeAluno.vue?vue&type=script&lang=js"

import "./HomeAluno.vue?vue&type=style&index=0&id=827849f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__